/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../client/js/components/PageTitle'
import RoleForm from '../components/RoleForm'
import { fetchRoleWithPermissions } from '../lib/roleAPIClient'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import Page from '../../../client/js/components/Page'
import AdminBreadcrumb from '../../../client/js/components/breadcrumb/AdminBreadcrumb'
import AnchorLink from '../../../client/js/components/AnchorLink'
import { getRoleListLink } from '../lib/roleLinks'
import BreadcrumbCard from '../../../client/js/components/breadcrumb/BreadcrumbCard'

function RoleFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const roleId = parseInt(params.id, 10)

  const roleQuery = useQuery({
    enabled: true,
    queryKey: ['role', roleId],
    queryFn: () => roleId > 0
      ? fetchRoleWithPermissions(roleId)
      : Promise.resolve({} as Partial<Role>),
    refetchOnWindowFocus: false
  })
  const { data: role } = roleQuery

  const title = roleId > 0 && role
    ? role.name
    : intl.formatMessage({
      id: 'create_role',
      defaultMessage: 'Créer un rôle'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getRoleListLink()}>
              <FormattedMessage
                id="roles"
                defaultMessage="Rôles"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <LoadingHelper
          query={roleQuery}
          render={() => (
            <Card shadow="sm">
              <RoleForm initialValues={role} />
            </Card>
          )}
        />
      </Container>
    </Page>
  )
}

export default RoleFormPage
